import React, { useEffect, useState } from "react";
import {
  whoami,
  getTeachers,
  getClasses,
  getSchools,
  getCountryId,
  getActiveGradeLevel3Schools
} from "../services/APIClient";
import { Link, useNavigate } from "react-router-dom";
import HeadingBanner from "../components/HeadingBanner";
import SandboxCard from "../components/SandboxCard";
import FolderCard from "../components/FolderCard";
import LeftPanel from "../components/LeftPanel";
import { Container, Row, Col } from "react-bootstrap";
import "../components/ClassCard.css";
import "../components/MasterDashCards.css";
import "../components/SandBox.css";
import OrientationPrompt from "../components/OrientationPrompt";

import Card from "react-bootstrap/Card";
import { Button } from "react-bootstrap";

const buttonStyle = {
  padding: '16px 24px',
  fontSize: '2.5vh',
  fontWeight: '600',
  backgroundColor: '#FF6B35',
  color: '#FFFFFF',
  border: 'none',
  borderRadius: '12px',
  cursor: 'pointer',
  boxShadow: '0 4px 12px rgba(255, 107, 53, 0.3)',
  transition: 'none',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  outline: 'none',
  marginBottom: '1%',
  width: '100%'
};

function BeforeScreening() {
  const [schoolid, setSchoolid] = useState(null);
  const [countryId, setCountryId] = useState(null);
  const [teacherid, setTeacherid] = useState(null);
  const [name, setName] = useState();
  const [teachers, setTeachers] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [displayFolders, setDisplayFolders] = useState(true);
  const [showButton, setShowButton] = useState(false);
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );
  const [gradeLevel3Schools, setGradeLevel3Schools] = useState([]);

  const englandId = "74bb2897-dbbe-41e3-b547-caee866545cf";
  const usaId = "ab40949f-001e-48b9-848e-126decad8471";
  const uaeId = "1cb16a5c-7c0a-4e7a-bcbc-b409024dd6cf";
  const malaysiaId = "f2d8569e-47ca-4e88-8736-797a7acd37f3";
  const northernIrelandId = "622e7844-a15e-4b91-9f64-12bf71ed7cff";
  const indiaId = "cd512001-3e26-4725-9a17-1155fc722db7";

  // Define Irish/Default content
  const sandboxcontent = [
    {
      folderName: "Screener Best Practices",
      cards: [
        {
          title: "Screener Best Practices",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/6a4sLVTmfFA?si=eg09UK9l0d4gi581" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
        },
      ],
    },

    // Baseline
    // {
    //   folderName: "Watch Video with children before screening",
    //   cards: [
    //     {
    //       title: "Watch Video with Juniors before screening",
    //       iframe:
    //         '<iframe width="672" height="378" src="https://www.youtube.com/embed/RYCtBPsQgZg?si=QiXtbgA68yrxEfzu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    //     },
    //     {
    //       title: "Watch Video with Seniors before screening",
    //       iframe:
    //         '<iframe width="672" height="378" src="https://www.youtube.com/embed/byobxVtCV74?si=PwTSjSvS0729zELy" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    //     },
    //   ],
    // },

    // Midpoint
     {
      folderName: "Watch Video with children before screening",
      cards: [
        {
          title: "Watch Video with Juniors before screening",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/RYCtBPsQgZg?si=QiXtbgA68yrxEfzu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
        },
        {
          title: "Watch Video with Seniors before screening",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/byobxVtCV74?si=PwTSjSvS0729zELy" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
        },
      ],
    },

    // Baseline
    // {
    //   folderName: "Review Word & Image lists for EAL/AEN pre screening",
    //   cards: [
    //     {
    //       title: "Junior Infants Word List - Baseline Screener",
    //       documentUrl:
    //         "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Grade%20Level%201%20Baseline%20Word%20&%20Image%20list.pdf",
    //     },
    //     {
    //       title: "Senior Infants Word List - Baseline Screener",
    //       documentUrl:
    //         "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Grade%20Level%202%20Baseline%20Word%20&%20Image%20list.pdf",
    //     },
    //   ],
    // },

    // Midpoint
    {
      folderName: "Review Word & Image lists for EAL/AEN pre screening",
      cards: [
        {
          title: "Junior Infants Word List - Baseline Screener",
          documentUrl:
            "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Grade%20Level%201%20Baseline%20Word%20&%20Image%20list.pdf",
        },
        {
          title: "Senior Infants Word List - Baseline Screener",
          documentUrl:
            "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Grade%20Level%202%20Baseline%20Word%20&%20Image%20list.pdf",
        },
      ],
    },
  ];

  // Define UK-specific content
  const sandboxcontentUK = [
    {
      folderName: "Screener Best Practices",
      cards: [
        {
          title: "Screener Best Practices",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/6a4sLVTmfFA?si=eg09UK9l0d4gi581" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
        },
      ],
    },


    // {
    //   folderName: "Watch Video with children before screening",
    //   cards: [
    //     {
    //       title: "Watch Video with Reception before screening",
    //       iframe:
    //         '<iframe width="672" height="378" src="https://www.youtube.com/embed/nxMDULDDMo8?si=attDOVthlYsfRbO2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
    //     },
    //     {
    //       title: "Watch Video with Year 1 before screening",
    //       iframe:
    //         '<iframe width="672" height="378" src="https://www.youtube.com/embed/5JWSSI9jRys?si=ihh8uislj9DBux7Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
    //     },
    //   ],
    // },

    // End of Year
     {
      folderName: "Watch Video with children before screening",
      cards: [
        {
          title: "Watch Video with Reception before screening",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/nxMDULDDMo8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
        },
        {
          title: "Watch Video with Year 1 before screening",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/5JWSSI9jRys" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
        },
      ],
    },



    // {
    //   folderName: "Review Word & Image lists for EAL/AEN pre screening",
    //   cards: [
    //     {
    //       title: "Reception Word List - Baseline Screener",
    //       documentUrl:
    //         "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Reception%20Baseline%20Word%20&%20Image%20list.pdf",
    //     },
    //     {
    //       title: "Year 1 Word List - Baseline Screener",
    //       documentUrl:
    //         "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Year%201%20Baseline%20Word%20&%20Image%20list.pdf",
    //     },
    //   ],
    // },

    // End of Year
{
      folderName: "Review Word & Image lists for EAL/AEN pre screening",
      cards: [
        {
          title: "Reception Word List - Baseline Screener",
          documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Reception%20Baseline%20Word%20&%20Image%20list.pdf",
        },
        {
          title: "Year 1 Word List - Baseline Screener",
          documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Year%201%20Baseline%20Word%20&%20Image%20list.pdf",
        },
      ],
    },
  ];

  // Define USA-specific content
  const sandboxcontentUSA = [
    {
      folderName: "Screener Best Practices",
      cards: [
        {
          title: "Screener Best Practices",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/6a4sLVTmfFA?si=eg09UK9l0d4gi581" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
        },
      ],
    },

    // {
    //   folderName: "Watch Video with children before screening",
    //   cards: [
    //     {
    //       title: "Watch Video with Pre-K before screening",
    //       iframe:
    //         '<iframe width="672" height="378" src="https://www.youtube.com/embed/J7XIa4QXpDk?si=Y4pPa78DwXzH5Nf3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
    //     },
    //     {
    //       title: "Watch Video with Kindergarten before screening",
    //       iframe:
    //         '<iframe width="672" height="378" src="https://www.youtube.com/embed/5KLlAJX_qjg?si=L6EKC5EWYd3JIiHx" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
    //     },
    //   ],
    // },

    // Midpoint
    {
      folderName: "Watch Video with children before screening",
      cards: [
        {
          title: "Watch Video with Pre-K before screening",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/Wze4acpFG5M?si=R9Qgu65LZgW_T4Z_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
        },
        {
          title: "Watch Video with Kindergarten before screening",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/04gpHzRb-q4?si=mrHMYb6uiczXrydM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
        },
      ],
    },


    {
      folderName: "Review Word & Image lists for EAL/AEN pre screening",
      cards: [
        {
          title: "Pre-K Word List - Midpoint Screener",
          documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel1%20Word%20&%20Image%20list%20-%20Midpoint.pdf",
        },
        {
          title: "Kindergarten Word List - Midpoint Screener",
          documentUrl:
        "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel2%20Word%20&%20Image%20list%20-%20Midpoint.pdf",
        },
      ],
    },
  ];

  // Define UAE-specific content
  const sandboxcontentUAE = [
    {
      folderName: "Screener Best Practices",
      cards: [
        {
          title: "Screener Best Practices",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/6a4sLVTmfFA?si=eg09UK9l0d4gi581" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
        },
      ],
    },



    {
      folderName: "Watch Video with children before screening",
      cards: [
        {
          title: "Watch Video with KG1 before screening",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/gMrbihlzlVI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
        },
        {
          title: "Watch Video with KG2 before screening",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/nesNSdq3oX4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
        },
      ],
    },


    {
      folderName: "Review Word & Image lists for EAL/AEN pre screening",
      cards: [
        {
          title: "KG1 Word List - Baseline Screener",
          documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/KG1%20Baseline%20Word%20&%20Image%20list%20V2.pdf",
        },
        {
          title: "KG2 Word List - Baseline Screener",
          documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/KG2%20Baseline%20Word%20&%20Image%20list%20V2.pdf",
        },
      ],
    },
  ];

  const sandboxcontentNI = [
    {
      folderName: "Screener Best Practices",
      cards: [
        {
          title: "Screener Best Practices",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/6a4sLVTmfFA?si=eg09UK9l0d4gi581" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
        },
      ],
    },



    {
      folderName: "Watch Video with children before screening",
      cards: [
        {
          title: "Watch Video with P1 before screening",
          // Irish Version: "https://www.youtube.com/embed/i0gclNlkfCM"
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/J7m0DRW8DiM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
        },
        {
          title: "Watch Video with P2 before screening",
          // Irish Version: "https://www.youtube.com/embed/l3jRDUCs77E"
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/09tQNqn3ICo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
        },
      ],
    },


    {
      folderName: "Review Word & Image lists for EAL/AEN pre screening",
      cards: [
        {
          title: "P1 Word List - Baseline Screener",
          // Irish Version: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/P1%20Baseline%20Word%20&%20Image%20list%20-%20Ire%20Version.pdf"
          documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/P1%20Baseline%20Word%20&%20Image%20list.pdf",
        },
        {
          title: "P2 Word List - Baseline Screener",
          // Irish Version: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/P2%20Baseline%20Word%20&%20Image%20list%20-%20Ire%20Version.pdf"
          documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/P2%20Baseline%20Word%20&%20Image%20list.pdf",
        },
      ],
    },
  ];

  const sandboxcontentIndia = [
    {
      folderName: "Screener Best Practices",
      cards: [
        {
          title: "Screener Best Practices",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/6a4sLVTmfFA?si=eg09UK9l0d4gi581" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
        },
      ],
    },



    {
      folderName: "Watch Video with children before screening",
      cards: [
        {
          title: "Watch Video with LKG before screening",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/D5FeMLrFOjA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
        },
        {
          title: "Watch Video with UKG before screening",
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/FiJOsoI9lls" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
        },
      ],
    },


    {
      folderName: "Review Word & Image lists for EAL/AEN pre screening",
      cards: [
        {
          title: "LKG Word List - Baseline Screener",
          documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/India%20LKG%20Baseline%20Word%20&%20Image%20list.pdf",
        },
        {
          title: "UKG Word List - Baseline Screener",
          documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/India%20UKG%20Baseline%20Word%20&%20Image%20list.pdf",
        },
      ],
    },
  ];

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    window.HubSpotConversations?.widget?.refresh();
  }, []);

  useEffect(() => {
    whoami().then((response) => {
      setSchoolid(response.data.stakeholder.schoolid);
      setTeacherid(response.data.stakeholder.id);
      setName(response.data.stakeholder.name);
    });
  }, []);

  useEffect(() => {
    getTeachers(schoolid).then((response) => {
      setTeachers(response);
    });
  }, [schoolid]);

  useEffect(() => {
    if (schoolid) {
      getCountryId(schoolid)
        .then((response) => {
          if (response.countryId) {
            console.log(response)
            setCountryId(response.countryId);
          } else {
            console.warn("No country ID found for school:", response.message);
            setCountryId(null);
          }
        })
        .catch((error) => {
          console.error("Failed to fetch country ID:", error);
          setCountryId(null);
        });
    }
  }, [schoolid]);

  // Fetch GradeLevel3 schools on mount
  useEffect(() => {
    const fetchGradeLevel3Schools = async () => {
      try {
        const activeSchools = await getActiveGradeLevel3Schools();
        setGradeLevel3Schools(activeSchools);
        console.log("Active GradeLevel3 schools:", activeSchools);
      } catch (error) {
        console.error("Error fetching GradeLevel3 schools:", error);
        setGradeLevel3Schools([]);
      }
    };

    fetchGradeLevel3Schools();
  }, []);

  const toggleDisplay = () => {
    setSelectedFolder(null);
    setDisplayFolders(!displayFolders);
    setShowButton(!displayFolders);
  };

  const hideButton = () => {
    setShowButton(false);
  };

  const handleFolderClick = (folderIndex) => {
    setSelectedFolder(selectedFolder === folderIndex ? null : folderIndex);
    setDisplayFolders(false);
    setShowButton(true);
  };

  // Determine which content to display based on the countryId
  let selectedSandboxContent;

  if (countryId === englandId || countryId === malaysiaId) {
    selectedSandboxContent = sandboxcontentUK;
  } else if (countryId === usaId) {
    selectedSandboxContent = sandboxcontentUSA;
  } else if (countryId === uaeId) {
    selectedSandboxContent = sandboxcontentUAE;
  } else if (countryId === northernIrelandId ) {
    selectedSandboxContent = sandboxcontentNI;
  } else if (countryId === indiaId ) {
    selectedSandboxContent = sandboxcontentIndia; 
  } else {
    selectedSandboxContent = sandboxcontent; // Irish/Default

    // Add 1st Class resources for allowed schools
    if (schoolid && gradeLevel3Schools.includes(schoolid)) {
      selectedSandboxContent = JSON.parse(JSON.stringify(selectedSandboxContent)); // Deep clone

      // Add to video folder (index 1)
      selectedSandboxContent[1].cards.push({
        title: "Watch Video with 1st Class before screening",
        iframe: '<iframe width="672" height="378" src="https://www.youtube.com/embed/7qzWqnzO-Ho" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
      });

      // Add to word list folder (index 2)
      selectedSandboxContent[2].cards.push({
        title: "1st Class Word List - Baseline Screener",
        documentUrl: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/1st%20Class%20Word%20%26%20Image%20list%20-%20Baseline.pdf"
      });
    }
  }

  // Dynamic text function
  const getDynamicText = () => {
    // When showing all folders (initial view)
    if (displayFolders) {
      return "Please use these videos in class before screening. Also review the word and images used with your EAL and AEN. This will ensure all children understand the question types asked and all words and images used are clearly understood.";
    }

    // When a specific folder is selected
    if (selectedFolder !== null && selectedSandboxContent[selectedFolder]) {
      const folderName = selectedSandboxContent[selectedFolder].folderName;

      if (folderName === "Screener Best Practices") {
        return "This video will help teachers ensure the correct device & classroom set up before screening the children.";
      }

      if (folderName.includes("Word & Image Lists")) {
        return "Please use these word lists with your EAL and AEN children before screening. This is not to pre teach but ensure the words and images used are clearly understood and identifiable";
      }

      if (folderName.includes("Watch Video with children before screening")) {
        return "Please make sure to show this video to your class before screening. If you do that, children will understand they are about to go play a game and they will realize there are different types of questions that are going to be asked. You can make it an interactive activity in the classroom where you play the video in front of whole class, pause it after each question and ask for volunteers to give the answer.";
      }
    }

    // Fallback text
    return "Select a folder to view resources and guidance.";
  };

  return (
    <div>
      <Container fluid className="vh-100">
        <HeadingBanner
          name={name + "'s" + " " + "Before Screening Resources"}
          isLoggedIn={true}
          cloud={true}
          teacherid={teacherid}
        />

        <Row className="h-100">
          <LeftPanel />
          <Col sm={{ span: 10, offset: 2 }} className="blue-background">
            <Row className="sandbox-row-position">
              {showButton && (
                <Button
                  className="sandbox-button"
                  onClick={() => {
                    toggleDisplay();
                    hideButton();
                  }}
                >
                  Back
                </Button>
              )}
            </Row>

            <Row>
              <Col>
                <div style={{
                  backgroundColor: '#cc5182ff',
                  border: '2px solid #f43782ff',
                  borderRadius: '12px',
                  padding: '10px',
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  fontSize: '2.5vh',
                  fontWeight: '600',
                  color: '#ffffffff',
                  margin: '0 auto',
                }}>
                  {getDynamicText()}
                </div>
              </Col>
            </Row>

            <Row className="sandbox-row-position">
              {displayFolders
                ? selectedSandboxContent.map((folder, folderIndex) => (
                  <FolderCard
                    key={folderIndex}
                    folderName={folder.folderName}
                    onClick={() => handleFolderClick(folderIndex)}
                  />
                ))
                : null}
              {selectedFolder !== null &&
                selectedSandboxContent[selectedFolder] &&
                selectedSandboxContent[selectedFolder].cards.map(
                  (card, cardIndex) => (
                    <SandboxCard
                      key={cardIndex}
                      title={card.title}
                      iframe={card.iframe}
                      documentUrl={card.documentUrl}
                    />
                  )
                )}
            </Row>

            <Link to="/assessmentsdashboard">
              <button
                style={buttonStyle}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#FF6B35';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#FF6B35';
                }}
                onFocus={(e) => {
                  e.target.style.outline = 'none';
                }}
              >
                <strong>Remember to Assign Screeners before Screening</strong>
              </button>
            </Link>

          </Col>
        </Row>
        {isPortrait && <OrientationPrompt />}
      </Container>
    </div>
  );
}

export default BeforeScreening;